import { runClientComponent } from '../../_common/client/client-component-runner';
import { RecoAddOnSalesComponent } from './reco-add-on-sales.component';

runClientComponent({ RecoAddOnSalesComponent });
